<template>
  <div>
    <header class="humming-bird-header flex rounded sm:py-6">
      <div class="relative inline-block w-full">
        <div class="wrap-filter-content">
          <date-picker ref="datepicker" v-model="dateDisplay" />

          <occupancy-selector
            ref="occupancySelector"
            placeholder="Add guests & rooms"
          />

          <button
            @click="checkAvailability"
            :disabled="disabledCheckAvailability || isLoadingRooms"
            class="flex items-center btn btn-secondary btn-outlined justify-center hbt-price-search-cta"
          >
            {{ ctaTitle }}
          </button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "./DatePicker";
import OccupancySelector from "./OccupancySelector";
export default {
  components: {
    DatePicker,
    OccupancySelector,
  },
  computed: {
    ...mapState(["dates", "roomsFilter", "isLoadingRooms"]),
    dateDisplay: {
      get() {
        return this.dates;
      },
      set(val) {
        this.$store.commit("setDates", val);
      },
    },
    disabledCheckAvailability() {
      return !this.dates.length || (!this.dates[0] && !this.dates[1]);
    },
    ctaTitle() {
      let same = true;

      const searchParams = new URLSearchParams(window.location.search);
      const from = this.dates[0]
        ? moment(this.dates[0]).format("YYYY-MM-DD")
        : null;
      const to = this.dates[1]
        ? moment(this.dates[1]).format("YYYY-MM-DD")
        : this.dates[0];

      const roomData = this.roomsFilter.map((room) => {
        const children = room.children.map((child) => {
          return child.age;
        });

        if (children.length) {
          return `guests:${room.adults},children:${
            room.children.length
          },ageChild:${children.join("_")}`;
        }
        return `guests:${room.adults},children:${room.children.length}`;
      });

      roomData.forEach((_r, index) => {
        if (searchParams.get(`room${index + 1}`) !== _r) {
          same = false;
        }
      });

      if (searchParams.get("filter") !== `from:${from},to:${to}`) same = false;

      let roomTotal = 0;

      for (let i = 1; i < 5; i++) {
        if (searchParams.has(`room${i}`)) {
          roomTotal++;
        }
      }

      if (roomTotal !== roomData.length) {
        same = false;
      }

      if (same || !searchParams.get("filter")) {
        return "Search";
      } else {
        return "Update search";
      }
    },
  },
  methods: {
    checkAvailability() {
      this.$store.dispatch("loadRooms", "update-search");
    },
    showDatePicker() {
      this.$refs.datepicker.show();
    },
    showOccupancySelector() {
      this.$refs.occupancySelector.showAndSelectDefault();
    },
  },
  watch: {
    dateDisplay(value) {
      const [from, to] = value;

      // check if both from and to are valid moment object
      if (from && to && from.isValid() && to.isValid()) {
        this.$nextTick(() => {
          this.$refs.datepicker.hide();
          setTimeout(() => {
            this.$refs.occupancySelector.showAndSelectDefault();
          }, 200);
        });
      }

      if (from === null && to === null) {
        this.$store.dispatch("clearResult");
      }
    },
  },
};
</script>

<style scoped>
.wrap-filter-content {
  display: flex;
  column-gap: 1.25rem;
  padding: 12px 24px;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  background: #f6f6f6;
  justify-content: center;
}

.hbt-price-search-cta {
  min-width: 200px;
}

@media (max-width: 600px) {
  .wrap-filter-content {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding: 1rem;
    border-radius: unset;
    border: unset;
    background-color: #f6f6f6;
  }

  .humming-bird-header {
    background-color: #ffffff;
    padding: 0px;
  }
}
</style>
